import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { encrypt, decrypt } from '@/utils'

interface User {
  customerId: number;
  email: string;
  headPic: string;
  name: string;
  nickName: string;
  phone: string;
  phoneCode: string;
}

interface Student {
  id: number;
  name: string;
  headPic: string;
  sex: number;
  invitationCode: string | null;
  countryId: number;
}


interface AuthState {
  uid: number | string | null;
  stuId: number | string | null;
  token: string | null;
  userInfo: User | null;
  studentLists: Student[];
}

const initialState: AuthState = {
  token: null,
  stuId: null,
  uid: null,
  userInfo: null,
  studentLists: []
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
      // 将token保存到LocalStorage
      localStorage.setItem('token', encrypt(action.payload || ''));
    },
    loadToken: (state) => {
      // 从LocalStorage加载token
      try {
        const tokenInLocalStorage = localStorage.getItem('token') && decrypt(localStorage.getItem('token'));
        state.token = tokenInLocalStorage ? tokenInLocalStorage : null;
      } catch (error) {
        console.log(error);
      }
    },

    setStuId: (state, action: PayloadAction<string | null>) => {
      console.log(action.payload,'---a----');
      
      state.stuId = action.payload;
      // 将stuId保存到LocalStorage
      localStorage.setItem('stuId', encrypt(action.payload || ''));
    },
    loadStuId: (state) => {
      // 从LocalStorage加载stuId
      const stuIdInLocalStorage = localStorage.getItem('stuId') && decrypt(localStorage.getItem('stuId'));
      state.stuId = stuIdInLocalStorage ? stuIdInLocalStorage : null;
    },

    setUid: (state, action: PayloadAction<string | null>) => {
      state.stuId = action.payload;
      // 将uid保存到LocalStorage
      localStorage.setItem('uid', encrypt(action.payload || ''));
    },
    loadUid: (state) => {
      // 从LocalStorage加载uid
      const uidInLocalStorage = localStorage.getItem('uid') && decrypt(localStorage.getItem('uid'));
      state.uid = uidInLocalStorage ? uidInLocalStorage : null;
    },


    setUserInfo: (state, action: PayloadAction<User | null>) => {
      state.userInfo = action.payload;
    },
    setStudentLists: (state, action: PayloadAction<Student[]>) => {
      state.studentLists = action.payload;
    },
  },
});

export const { setToken, loadToken, setUserInfo, setStuId,
  loadStuId,
  setUid,
  loadUid, setStudentLists } = authSlice.actions;

export default authSlice.reducer;
